export default __webpack_public_path__ + "static/media/no-data.7e1ca706.jpg";